import { FC } from 'react';
import { UserActivityType } from '../types/super-admin-dashboard-dto';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type Props = {
    type: UserActivityType;
    className?: string;
};

const ActivityType: FC<Props> = ({ type, className }) => {
    const { t } = useTranslation();

    const activity = {
        [UserActivityType.Registration]: 'main.superAdmin.dashboard.activityType.registration',
        [UserActivityType.Login]: 'main.superAdmin.dashboard.activityType.login',
        [UserActivityType.ChangePassword]: 'main.superAdmin.dashboard.activityType.changePassword',
        [UserActivityType.ForgotPassword]: 'main.superAdmin.dashboard.activityType.forgotPassword',
    };

    return <span className={cn('text-sm text-popover-800', className)}>{t(activity[type])}</span>;
};

export default ActivityType;
